import axios from '@/plugins/axios.js'

export function remove(id) {
    return axios.delete(`delivery/${id}`);
}

export function list(params) {
    return axios.get("/delivery/list", { params: params });
}